/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiAuthCallbackProviderGet } from '../fn/callback/api-auth-callback-provider-get';
import { ApiAuthCallbackProviderGet$Params } from '../fn/callback/api-auth-callback-provider-get';
import { callbackProviderGet } from '../fn/callback/callback-provider-get';
import { CallbackProviderGet$Params } from '../fn/callback/callback-provider-get';

@Injectable({ providedIn: 'root' })
export class ApiRoamingCallbackService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiAuthCallbackProviderGet()` */
  static readonly ApiAuthCallbackProviderGetPath = '/api/auth/Callback/{provider}';

  /**
   * Handles the callback from the provider.
   *
   * Standard error codes OAuth (Google)
   * Error code(error)       Description(error_description)      When it occurs
   * access_denied           The user denied your request        The user denied access
   * invalid_request         Missing required parameter: code    Incorrect request(e.g.no client_id)
   * unauthorized_client     The client is not authorized        The application does not have permissions to the request
   * invalid_scope           Invalid OAuth scope                 Invalid scope requested(e.g.email instead of openid email)
   * invalid_grant           Invalid authorization code          Code is outdated or already used
   * server_error            Internal server error               Problem on Google side
   * temporarily_unavailable Service temporarily down            Temporary error(can be retried later)
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAuthCallbackProviderGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAuthCallbackProviderGet$Response(params: ApiAuthCallbackProviderGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiAuthCallbackProviderGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Handles the callback from the provider.
   *
   * Standard error codes OAuth (Google)
   * Error code(error)       Description(error_description)      When it occurs
   * access_denied           The user denied your request        The user denied access
   * invalid_request         Missing required parameter: code    Incorrect request(e.g.no client_id)
   * unauthorized_client     The client is not authorized        The application does not have permissions to the request
   * invalid_scope           Invalid OAuth scope                 Invalid scope requested(e.g.email instead of openid email)
   * invalid_grant           Invalid authorization code          Code is outdated or already used
   * server_error            Internal server error               Problem on Google side
   * temporarily_unavailable Service temporarily down            Temporary error(can be retried later)
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAuthCallbackProviderGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAuthCallbackProviderGet(params: ApiAuthCallbackProviderGet$Params, context?: HttpContext): Observable<void> {
    return this.apiAuthCallbackProviderGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `callbackProviderGet()` */
  static readonly CallbackProviderGetPath = '/Callback/{provider}';

  /**
   * Handles the callback from the provider.
   *
   * Standard error codes OAuth (Google)
   * Error code(error)       Description(error_description)      When it occurs
   * access_denied           The user denied your request        The user denied access
   * invalid_request         Missing required parameter: code    Incorrect request(e.g.no client_id)
   * unauthorized_client     The client is not authorized        The application does not have permissions to the request
   * invalid_scope           Invalid OAuth scope                 Invalid scope requested(e.g.email instead of openid email)
   * invalid_grant           Invalid authorization code          Code is outdated or already used
   * server_error            Internal server error               Problem on Google side
   * temporarily_unavailable Service temporarily down            Temporary error(can be retried later)
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `callbackProviderGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  callbackProviderGet$Response(params: CallbackProviderGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return callbackProviderGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Handles the callback from the provider.
   *
   * Standard error codes OAuth (Google)
   * Error code(error)       Description(error_description)      When it occurs
   * access_denied           The user denied your request        The user denied access
   * invalid_request         Missing required parameter: code    Incorrect request(e.g.no client_id)
   * unauthorized_client     The client is not authorized        The application does not have permissions to the request
   * invalid_scope           Invalid OAuth scope                 Invalid scope requested(e.g.email instead of openid email)
   * invalid_grant           Invalid authorization code          Code is outdated or already used
   * server_error            Internal server error               Problem on Google side
   * temporarily_unavailable Service temporarily down            Temporary error(can be retried later)
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `callbackProviderGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  callbackProviderGet(params: CallbackProviderGet$Params, context?: HttpContext): Observable<void> {
    return this.callbackProviderGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
